import state from './moduleAuthState';
import getters from './moduleAuthGetters';
import actions from './moduleAuhActions';
import mutations from './moduleAuthMutations';


export default {
    namespaced:true,
    state,
    getters,
    actions,
    mutations
}
